module.exports = __webpack_public_path__ + "img/phone_step4.4c7e2c7a.png";